import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import {
    FolderSocialAcquireProcessGridObject,
    FolderSocialAcquireProcessObject,
} from '@libs/types/src/services/object-type/folder/folder-social-acquire-process.object';
import {
    FolderSocialAcquireProcessCreateInput,
} from '@libs/types/src/services/input-type/folder/folder-social-acquire-process.create-input';
import {
    FolderSocialAcquireProcessUpdateInput,
} from '@libs/types/src/services/input-type/folder/folder-social-acquire-process.update-input';

@Injectable({ providedIn: 'root' })
export class FolderSocialAcquireProcessGqlService extends GqlServiceV2 {

    public getFolderSocialAcquireProcesses(input: GridInput, fragment: string): Promise<FolderSocialAcquireProcessGridObject> {
        return this.query<FolderSocialAcquireProcessGridObject>(
            `
                query($input: GridInput!) {
                    folderSocialAcquireProcess {    
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createFolderSocialAcquireProcess(
        input: FolderSocialAcquireProcessCreateInput,
        fragment: string,
    ) {
        return this.mutate<FolderSocialAcquireProcessObject>(
            `
                mutation($input: FolderSocialAcquireProcessCreateInput!) {
                    folderSocialAcquireProcess {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    updateFolderSocialAcquireProcess(
        input: FolderSocialAcquireProcessUpdateInput,
        fragment: string,
    ) {
        return this.mutate<FolderSocialAcquireProcessObject>(
            `
                mutation($input: FolderSocialAcquireProcessUpdateInput!) {
                    folderSocialAcquireProcess {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteFolderSocialAcquireProcess(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    folderSocialAcquireProcess {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
